import * as React from 'react';
import { safeHref } from '../helper';

export default function Actions({links}) {
  if (!links || !Array.isArray(links) || !links.length) return null;

  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  return (
    <div className='accordion-item__actions'>
      {links.map((link, idx) => {
        const href = safeHref(link.url);
        if (!href) return null;

        const target = link.target?.raw ?? link.target;

        const isExternal = /^https?:\/\//i.test(href) && !href.startsWith(origin);
        const openInNewTab = target === '_blank' || isExternal || href.includes('/contact?');
        const extra = openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};

        return <a key={idx} href={href} className='nv-cta-secondary nv-cta-secondary--small' {...extra}>{link.text}</a>;
      })}
    </div>
  );
}
